module.exports = __webpack_public_path__ + "img/realtor.21a9d8fb.png";